import React from 'react'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import Group from 'components/utils/Group'
import moment from 'moment'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import { MappedRequestAgentCallbackResult } from './RequestAgentCallbackModal'

interface Props {
  customer: MappedRequestAgentCallbackResult['customer']
}

export function RequestAgentCallbackConfirmationModal(props: Props) {
  const { callbackTime, callbackDate, email } = props.customer
  return (
    <ModalBase>
      <form>
        <ModalHeader title="Callback request sent" />
        <ModalBody>
          <ModalContent>
            <VerticalSpacer gap={20}>
              <Group direction="vertical" gap={20}>
                <BodyTextBlock variant="large">
                  A customer service agent will call you at
                </BodyTextBlock>
                <Group direction="vertical" gap={0}>
                  <BodyTextBlock variant="large" weight="bold">
                    Time: {callbackTime}
                  </BodyTextBlock>
                  <BodyTextBlock variant="large" weight="bold">
                    Date: {moment(callbackDate).format(DMY_CASUAL_FORMAT)}
                  </BodyTextBlock>
                </Group>
                <BodyTextBlock variant="large">
                  A confirmation email has been sent to {email}.
                </BodyTextBlock>
              </Group>
            </VerticalSpacer>
          </ModalContent>
        </ModalBody>
        <ModalFooter primaryActionProps={{ children: 'Close' }}/>
      </form>
    </ModalBase>
  )
}
